<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M32.81 7.44a1.5 1.5 0 010 2.12L18.372 24l14.44 14.44a1.5 1.5 0 01-2.122 2.12l-15.5-15.5a1.5 1.5 0 010-2.12l15.5-15.5a1.5 1.5 0 012.122 0z"/></svg>